module.exports = __webpack_public_path__ + "img/1-21.50d47d32.png";